<div class="overlay" *ngIf="loadSpinner">
  <div class="loader">Loading...</div>
</div>
<app-header></app-header> 
<div>
<router-outlet></router-outlet>
</div>
<footer class="md-padding">
    <div id="btmFooter" flex> 
      <!-- <img class = "mobile-logo" [src] = "imglist.secondLogo" alt = "logo"/> -->
      <p>&#169; {{opcoConfigObj.footer ? opcoConfigObj.footer : 'Life Sciences Digital. All right are reserved'}}</p>
    </div>
</footer>
